// @ts-ignore
import ifvisible from 'ifvisible.js';
import { useState, useEffect } from 'react';
import { verifyToken, refreshToken, logout } from 'core/context/actions';
import { useAuthorizationDispatch } from 'core/context';
import { useIdleTimer } from 'react-idle-timer';

const IDLE_DURATION = 15 * 60 * 1000;

export const useAuthToken = () : boolean =>
{
    const [ loading, setLoading ] = useState<boolean>(true);
    const dispatch = useAuthorizationDispatch();

    const handleOnIdle = async () =>
    {
        await logout({ dispatch });
    };

    useIdleTimer({
        timeout: IDLE_DURATION,
        onIdle: handleOnIdle,
        crossTab: {
            emitOnAllTabs: true
        },
        debounce: 500
    });

    useEffect(() => 
    {
        (async () => 
        {
            await verifyToken({ dispatch });
            setLoading(false);
        })();

        const refresh = refreshToken();

        const refreshTimer = ifvisible.onEvery(300, refresh);
        ifvisible.on('wakeup', async () =>
        {
            await refresh();
        });

        return () =>
        {
            ifvisible.off('wakeup');
            refreshTimer.stop();
        };
    }, []);

    return loading;
};